<template>
    <transition name="modal" duration="300">
    <div class="c-modal c-modal--animation c-modal--open c-modal__backdrop" :class="classes" v-if="active" @click.self="close">
        <div class="c-modal__dialog">
            <div class="c-modal__content">
                <div class="c-modal__hero" v-if="hasHeroSlot">
                   <slot name="hero"></slot>
                    <div class="c-modal__close">
                        <i class="fal fa-times c-modal__close-btn u-text-neutral-00" @click="close"></i>
                    </div>
                </div>
                <div class="c-modal__header" v-if="title">
                    <h2 class="c-modal__title">{{ title }}</h2>
                    <div class="c-modal__close" v-if="!hasHeroSlot">
                        <i class="fal fa-times c-modal__close-btn" @click="close"></i>
                    </div>
                </div>
                <div class="c-modal__body">
                    <slot></slot>
                </div>

                <div class="c-modal__footer" v-if="hasFooterSlot">
                    <slot name="footer" close="close()"></slot>
                </div>
            </div>
        </div>
    </div>
    </transition>
</template>
<script>
    export default {
        props: ['name', 'title', 'value', 'classes'],
        data() {
            return {
                active: this.value,
            }
        },
        mounted() {
            window.Event.$on('modal.open', (name) => {
                if(name === this.name){
                    this.active = true
                }
            });
        },
        computed: {
            hasDefaultSlot () {
                return !!this.$slots.default
            },
            hasHeroSlot () {
                return !!this.$slots['hero']
            },
            hasFooterSlot () {
                return !!this.$slots['footer']
            }
        },
        watch: {
            value(value){
                this.active = value;
            },
            active(value){
                this.$emit('input', value);
            }
        },
        events: {
            openModal: function() {
                this.active = true;
            }
        },
        methods: {
            close() {
                this.active = false;
            },
            open() {
                this.active = true;
            }
        },
    }
</script>
